/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var E;!function(E){E[E.INSIDE=0]="INSIDE",E[E.INTERSECTS=1]="INTERSECTS",E[E.OUTSIDE=2]="OUTSIDE"}(E||(E={}));export{E as TileFrustumVisibility};
